import { Component, EventEmitter, Output, OnInit, AfterViewInit,ViewChild, ElementRef  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError, of } from 'rxjs';
import { phoneOrEmailValidator } from '../../services/phoneOrEmialValidator';
import { Api } from '../../services/api';
import { AuthService } from '../../services/auth-service';
import { Router } from '@angular/router';
declare global {
  interface Window {
    google: any;
  }
}

declare const google: any;

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.html',
  styleUrls: ['./login.scss']
})
export class Login implements OnInit, AfterViewInit {
  @ViewChild('googleBtn', { static: false }) googleBtn!: ElementRef;
  isOpen = false;
  activeForm: 'login' | 'signup' | 'forgot' | 'register' | 'enquiry' = 'login';
  googleClientId = '38398634187-rovv61vba8tm5npfitsf20i4dv0b6ndi.apps.googleusercontent.com';
  currentStep = 1;
  isLoading = false;
  showPassword:boolean = false;
  
  classes: any[] = [];
  sections: any[] = [];
  filteredSections: any[] = [];
  isValidSchoolId = false;
  
  loginForm: FormGroup;
  signupStep1Form: FormGroup;
  signupStep2Form: FormGroup;
  forgotForm: FormGroup;
  registerForm!: FormGroup;
  enquiryForm!: FormGroup;
  registerSubmitted: boolean = false;
  enquirySubmitted: boolean = false;
  

  loginSubmitted = false;
  forgotSubmitted = false;
  
  @Output() modalClosed = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private apiService: Api,
    private authService: AuthService,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      schoolId: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      phoneNumber: ['', [phoneOrEmailValidator]],
      password: ['', [Validators.required, Validators.minLength(4)]]
    });

    this.signupStep1Form = this.fb.group({
      schoolId: ['', Validators.required],
      classOrder: ['', Validators.required],
      sectionId: ['', Validators.required],
      userType: ['PARENT', Validators.required]
    });

    this.signupStep2Form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: [''],
      gender: ['M', Validators.required],
      phoneNumber: ['', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern(/^\d{10}$/)
      ]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      email: ['', [
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ]]
    });

    this.forgotForm = this.fb.group({
      schoolId: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      phoneNumber: ['', [phoneOrEmailValidator]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });

    this.initRegisterForm();
    this.enquiryFormValidator() 
  }


  ngOnInit():void {
      this.signupStep1Form.statusChanges.subscribe(status => {
    console.log('Step1 Status:', status);
  });

  this.signupStep2Form.statusChanges.subscribe(status => {
    console.log('Step2 Status:', status);
  });
  }
checkStep2Errors() {
  console.log('===== STEP 2 DEBUG =====');
  console.log('Form Valid:', this.signupStep2Form.valid);
  console.log('Form Status:', this.signupStep2Form.status);

  Object.keys(this.signupStep2Form.controls).forEach(key => {
    const control = this.signupStep2Form.get(key);

    console.log('-------------------------');
    console.log('Field:', key);
    console.log('Value:', control?.value);
    console.log('Valid:', control?.valid);
    console.log('Errors:', control?.errors);
  });
}
 openModal(formType: 'login' | 'signup' | 'forgot' | 'register' | 'enquiry' = 'login') {

  this.activeForm = formType;
  this.isOpen = true;
  document.body.style.overflow = 'hidden';

  setTimeout(() => {

    if (typeof google === 'undefined') {
      console.error("Google script not loaded yet");
      return;
    }

    this.initializeGoogleLogin();

  }, 300);

}

  closeModal() {
    this.isOpen = false;
    document.body.style.overflow = 'auto';
    this.modalClosed.emit();
    this.resetForms();
  }

 resetForms() {
  this.loginForm.reset();
  this.signupStep1Form.reset({ userType: 'PARENT' });
  this.signupStep2Form.reset({ gender: 'M' });
  this.forgotForm.reset();
  this.registerForm.reset();
  this.enquiryForm.reset();

  this.loginSubmitted = false;
  this.forgotSubmitted = false;
  this.enquirySubmitted = false;
  this.currentStep = 1;
}


  switchToLogin(event: Event) {
    event.preventDefault();
    this.activeForm = 'login';
  }

  switchToSignup(event: Event) {
    event.preventDefault();
    this.activeForm = 'signup';
    this.currentStep = 1;
  }

  switchToForgot(event: Event) {
    event.preventDefault();
    this.activeForm = 'forgot';
  }

  onLoginSubmit() {
    this.loginSubmitted = true;
    
    if (this.loginForm.invalid) {
      this.apiService.displayToast('Please enter valid credentials', 100);
      return;
    }

    this.isLoading = true;
    const formValues = this.loginForm.getRawValue();
    
    // Normalize values
    Object.keys(formValues).forEach(key => {
      if (typeof formValues[key] === 'string') {
        formValues[key] = formValues[key]
          .normalize('NFC')
          .replace(/[\u200C\u200B\s]/g, '')
          .trim();
      }
    });

    // Call the API service to get school data
    this.apiService.getSchoolData(formValues.schoolId).subscribe({
      next: (school: any) => {
        if (!school?.data?.hostUrl) {
          this.apiService.displayToast('School ID not found', 500);
          this.isLoading = false;
          return;
        }

        // Continue with login logic
        this.authService.login(school.data.hostUrl, formValues).subscribe({
          next: (user: any) => {
            this.isLoading = false;
            if (user.status === 422 || user.status === 404) {
              this.apiService.displayToast(
                user.msg || user.message || 'Something went wrong',
                500
              );
              return;
            }
            
            // Handle successful login
            this.handleSuccessfulLogin(user, school.data);
          },
          error: (error: { error: { message: any; }; }) => {
            this.isLoading = false;
            this.apiService.displayToast(
              error.error?.message || 'Login failed',
              500
            );
          }
        });
      },
      error: () => {
        this.isLoading = false;
        this.apiService.displayToast('School ID not found', 500);
      }
    });
  }
 ngAfterViewInit(): void {
    this.initializeGoogleLogin();
  }
initializeGoogleLogin() {

  if (!this.googleBtn) {
    console.error("googleBtn not found");
    return;
  }

  const element = this.googleBtn.nativeElement;

  element.innerHTML = "";

  google.accounts.id.initialize({
    client_id: this.googleClientId,
    callback: (response: any) => this.handleGoogleLogin(response)
  });

  google.accounts.id.renderButton(
    element,
    {
      theme: 'outline',
      size: 'large',
      width: 250
    }
  );

}


handleGoogleLogin(response: any) {

  const idToken = response.credential;

  console.log("Google Token:", idToken);

  // Send token to your backend
  this.authService.googleLogin(idToken).subscribe({
    next: (res: any) => {

      localStorage.setItem('user', JSON.stringify(res));

      this.apiService.displayToast('Google Login Successful', 200);

      this.closeModal();

      this.router.navigate(['/main-course']);
    },
    error: () => {
      this.apiService.displayToast('Google login failed', 500);
    }
  });

}
  handleSuccessfulLogin(user: any, schoolData: any) {
    this.closeModal();
    this.router.navigate(['/main-course'])
  }

  onSignupStep1Submit() {
    if (this.signupStep1Form.invalid) {
      this.signupStep1Form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const payload = { ...this.signupStep1Form.value };

    this.apiService.getSchoolData(payload.schoolId.trim()).subscribe({
      next: (res: any) => {
        const hostUrl = res.data?.hostUrl;
        if (hostUrl) {
          this.authService.verifySchoolCodes(hostUrl, payload).subscribe({
            next: (res: any) => {
              this.isLoading = false;
              if (res.schoolId) {
                this.currentStep = 2;
              } else {
                this.apiService.displayToast('Invalid School, Class or Section Id', 100);
              }
            },
            error: () => {
              this.isLoading = false;
              this.apiService.displayToast('Verification failed', 500);
            }
          });
        } else {
          this.isLoading = false;
          this.apiService.displayToast('Invalid School ID', 100);
        }
      },
      error: () => {
        this.isLoading = false;
        this.apiService.displayToast('School lookup failed', 500);
      }
    });
  }

  onSignupSubmit() {
    this.checkStep2Errors(); 
    if (this.signupStep1Form.invalid || this.signupStep2Form.invalid) {
      this.signupStep1Form.markAllAsTouched();
      this.signupStep2Form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const schoolId = this.signupStep1Form.value.schoolId.trim();

    this.apiService.getSchoolData(schoolId).subscribe({
      next: (school: any) => {
        if (!school?.data?.hostUrl) {
          this.apiService.displayToast('School ID not found', 500);
          this.isLoading = false;
          return;
        }

        const hostUrl = school.data.hostUrl;
        const payload = {
          ...this.signupStep2Form.value,
          ...this.signupStep1Form.value,
          fullName: `${this.signupStep2Form.value.firstName.trim()} ${this.signupStep2Form.value.lastName.trim()}`
        };

        this.authService.signup(hostUrl, payload).subscribe({
          next: (res: any) => {
            this.isLoading = false;
            if (res.status === 422 || res.status === 404 || res.data?.status === 409) {
              const msg = res.data?.msg || res.data?.message || res.message || res.msg || 'Something went wrong';
              this.apiService.displayToast(msg, 500);
              return;
            }

            if (res.success) {
              this.apiService.displayToast('Signed up successfully', 200);
              this.activeForm = 'login';
              this.currentStep = 1;
            } else {
              const msg = res.data?.msg || res.data?.message || res.message || res.msg || 'Sign up failed';
              this.apiService.displayToast(msg, 500);
            }
          },
          error: (err: { error: { data: { msg: any; }; message: any; }; }) => {
            this.isLoading = false;
            const msg = err.error?.data?.msg || err.error?.message || 'Sign up failed';
            this.apiService.displayToast(msg, 500);
          }
        });
      },
      error: () => {
        this.isLoading = false;
        this.apiService.displayToast('School lookup failed', 500);
      }
    });
  }

  onForgotSubmit() {
    this.forgotSubmitted = true;

    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const payload = { ...this.forgotForm.value };

    this.apiService.getSchoolData(payload.schoolId.trim()).subscribe({
      next: (res: any) => {
        const hostUrl = res.data?.hostUrl;
       
        this.authService.forgotPassword(hostUrl, payload).subscribe({
          next: (res: any) => {
            this.isLoading = false;
            
            if (res.status === 422 || res.status === 404 || res.status === 409) {
              this.apiService.displayToast(
                res.msg || res.message || 'Something went wrong',
                500
              );
              return;
            }

            this.forgotForm.reset();
            this.forgotSubmitted = false;
            this.apiService.displayToast('Password updated successfully', 200);
            this.activeForm = 'login';
          },
          error: () => {
            this.isLoading = false;
            this.apiService.displayToast('Something went wrong', 500);
          }
        });
      },
      error: () => {
        this.isLoading = false;
        this.apiService.displayToast('Something went wrong', 500);
      }
    });
  }

  validateSchoolId(event: any, form: FormGroup) {
    const value = event?.target?.value?.trim();
    this.isValidSchoolId = false;

    this.apiService.getSchoolData(value)
      .pipe(catchError(() => of(null)))
      .subscribe((school: any) => {
        if (school?.data?.hostUrl) {
          this.isValidSchoolId = true;
          localStorage.setItem('hostUrl', school?.data?.hostUrl);
      
          // Get class list for signup form
          if (form === this.signupStep1Form) {
            this.getSectionList(value, school.data.hostUrl);
          }
        } else {
          this.isValidSchoolId = false;
        }
      });
  }

  getSectionList(schoolId: string, hostUrl: string) {
    this.apiService.getAllSectionList(schoolId, hostUrl).subscribe({
      next: (classMap: any) => {
        const uniqueClasses = new Set();
        this.classes = classMap
          .filter((o: any) => {
            if (!uniqueClasses.has(o.classOrder)) {
              uniqueClasses.add(o.classOrder);
              return true;
            }
            return false;
          })
          .map((o: any) => o);
        
        this.sections = classMap;
      },
      error: () => {
        this.apiService.displayToast('Failed to load classes', 500);
      }
    });
  }

  onClassChange(event: any) {
    const classOrder = parseInt(event?.target?.value || '0');
    this.filteredSections = this.sections.filter((section: any) => 
      section.classOrder === classOrder
    );
  }

  formatFullName(name: string): string {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  openPrivacyPolicy() {
    window.open('https://www.kaboodleinnovations.com/privacy-policy', '_blank');
  }
showloginpass() {
  this.showPassword = !this.showPassword;
  console.log(this.showPassword)
}
  initRegisterForm() {
  this.registerForm = this.fb.group({
    schoolName: ['', Validators.required],
    fullName: ['', Validators.required],
    contactNumber: ['', [
      Validators.required,
      Validators.pattern('^[0-9]{10}$')
    ]],
    gender: ['', Validators.required],
    state: ['', Validators.required],
    city: ['', Validators.required],
    userRole: ['', Validators.required],
    isActive: [true, Validators.required]
  });
}
enquiryFormValidator() {
  this.enquiryForm = this.fb.group({
    fullName: ['', Validators.required],
    schoolName: ['', Validators.required],
    noOfChildren: ['', Validators.required],
    officialDesignation: ['', Validators.required],
    phoneNumber: [
      '',
      [Validators.required, Validators.pattern(/^\d{10}$/)]
    ],
    email: ['', [Validators.required, Validators.email]],
    city: ['', Validators.required],

    state: [''],
    country: [''],
    zipcode: ['']
  });
}




 Registration() {
  this.registerSubmitted = true;
  
  if (this.registerForm.invalid) return;

  this.isLoading = true;
  const payload = {
        schoolName: this.registerForm.value.schoolName.trim(),
        fullName: this.registerForm.value.fullName.trim(),
        contactNumber: this.registerForm.value.contactNumber.trim(),
        gender: this.registerForm.value.gender,
        city: this.registerForm.value.city.trim(),
        state: this.registerForm.value.state.trim(),
        isActive:  "true",
        userRole:this.registerForm.value.userRole.trim(),
      };
  this.authService.register(payload)
    .subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.apiService.displayToast('Registration successful !!', 200);
        this.closeModal();
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Registration failed:', err);
        this.apiService.displayToast('Registration failed', 500);
      }
    });
}
onEnquirySubmit() {
  this.enquirySubmitted = true;

  if (this.enquiryForm.invalid) {
    this.enquiryForm.markAllAsTouched();
    return;
  }
  this.isLoading = true;

  const payload = {
    fullName: this.enquiryForm.value.fullName.trim(),
    schoolName: this.enquiryForm.value.schoolName.trim(),
    noOfChildren: this.enquiryForm.value.noOfChildren,
    officialDesignation: this.enquiryForm.value.officialDesignation,
    phoneNumber: this.enquiryForm.value.phoneNumber.trim(),
    email: this.enquiryForm.value.email.trim(),
    city: this.enquiryForm.value.city.trim(),

    state: this.enquiryForm.value.state?.trim() || '',
    country: this.enquiryForm.value.country?.trim() || '',
    zipcode: this.enquiryForm.value.zipcode?.trim() || ''
  };

  this.apiService.Enquiry(payload).subscribe({
    next: () => {
      this.isLoading = false;
      this.apiService.displayToast('Enquiry submitted successfully!', 200);
      this.closeModal();
      this.enquiryForm.reset();
      this.enquirySubmitted = false;
    },
    error: () => {
      this.isLoading = false;
      this.apiService.displayToast('Enquiry submission failed', 500);
    }
  });
}



}